export default __webpack_public_path__ + "static/media/loading.dc10acae.svg";